import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex, Text } from "@similarweb/ui-components/foundations";

import signalEventsService from "app/pages/sales-intelligence/modules/company-analysis/services/signals/signalEventsService";
import type { SignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import { StyledSignalBoxLink } from "app/pages/sales-intelligence/pages/company-analysis/components/cards/signals-card/SignalEventBoxFooter/styles";
import { translate } from "app/filters/i18nFilter";
import SignalType from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalType";

type SignalEventBoxItemProps = {
    signal: SignalEventDto;
    onArticleLinkClick: (signalEvent: SignalEventDto) => void;
};

const SignalEventBoxItemFooter = ({ signal, onArticleLinkClick }: SignalEventBoxItemProps) => {
    const { eventHappenedDaysAgo, type } = signal;

    const handleArticleLinkClick = () => onArticleLinkClick(signal);

    return (
        <Flex
            alignItems="center"
            gap="12px"
        >
            <Text
                fontVariant="caption"
                color={colorsPalettes.carbon[250]}
                data-automation="signal-event-date"
            >
                {signalEventsService.getSignalEventDate(eventHappenedDaysAgo)}
            </Text>
            {type === SignalType.News && signal.url ? (
                <>
                    <Box
                        width="5px"
                        height="5px"
                        borderRadius="50%"
                        background={colorsPalettes.carbon[100]}
                    />
                    <StyledSignalBoxLink
                        href={signal.url}
                        target="_blank"
                        rel="noreferrer"
                        onMouseDown={handleArticleLinkClick}
                        data-automation="signal-event-news-link"
                    >
                        <span>{translate("si.company-analysis.signals.card.article")}</span>
                        <SWReactIcons
                            iconName="open-new-window"
                            size="12px"
                        />
                    </StyledSignalBoxLink>
                </>
            ) : null}
        </Flex>
    );
};

export default SignalEventBoxItemFooter;
